import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import { AlertOptions } from './sub-components/alert-options';
import 'AppSrc/core/style/components/utility/modal.css';


const alertDataShape = PropTypes.shape({
  alertTitle: PropTypes.string,
  Content: PropTypes.elementType,
  option: PropTypes.any,
  Icon: PropTypes.elementType,
  showFalse: PropTypes.bool,
  showTrue: PropTypes.bool,
  falseText: PropTypes.string,
  trueText: PropTypes.string,
  falseButtonCols: PropTypes.number,
  trueButtonCols: PropTypes.number,
  className: PropTypes.string,
});

class Modal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      resolveAlert,
      alertData,
    } = this.props;

    const {
      alertTitle,
      Content,
      option,
      falseText,
      trueText,
      falseButtonCols,
      trueButtonCols,
      Icon,
      showFalse,
      showTrue,
      className,
    } = alertData;
    const divClassName = `alert-section ${className || ''}`;
    return (
      <ModalPortal>
        <div
          className={divClassName}
        >
          <div className="alert-shadow" />
          <div className="alert-inner">
            { Icon && (
              <div className="alert-svg-wrapper">
                <button
                  className="svg-container"
                  type="button"
                  onClick={resolveAlert}
                >
                  <Icon />
                </button>
              </div>
            )}
            <div className="alert-texts">
              {
                alertTitle && (
                  <h1 className="alert-title">
                    {alertTitle}
                  </h1>
                )
              }
              {
                Content && (
                  <div className="alert-content">
                    <Content />
                  </div>
                )
              }
            </div>
            <AlertOptions
              onClick={resolveAlert}
              option={option}
              falseText={falseText}
              trueText={trueText}
              falseButtonCols={falseButtonCols}
              trueButtonCols={trueButtonCols}
              showFalse={showFalse}
              showTrue={showTrue}
            />
          </div>
        </div>
      </ModalPortal>
    );
  }
}

Modal.propTypes = {
  resolveAlert: PropTypes.func,
  alertData: alertDataShape,
};

export {
  Modal,
};



